module.exports = __webpack_public_path__ + "img/pieceOneImg4.9b1d406.webp";